import React, { useEffect } from 'react';
// Utils
import { isEmptyObject } from 'utils';
// Admin Context
import { useAdminDispatch, useAdminState } from 'context/AdminContext';
import { setUser } from 'context/AdminContext/actions';
import { getUser } from 'context/AdminContext/middleware';
// App Context
import { useAppDispatch } from 'context/AppContext';
// Elements
import Alert from 'elements/Alert';
// Components
import PageHeader from 'components/PageHeader';
import User from './components/User';
import UserSearchBar from './components/UserSearchBar';
// Style
import styles from './style/addUser.module.css';

function AddUser() {
  // Admin State
  const adminDispatch = useAdminDispatch();
  const { user } = useAdminState();
  // App State
  const appDispatch = useAppDispatch();
  // State
  const newUser = !isEmptyObject(user) && !user.startDate;

  useEffect(() => function cleanup() {
    adminDispatch(setUser({}));
  }, [adminDispatch]);

  return (
    <>
      <PageHeader
        customHeight={newUser ? '' : 140}
        heading={!newUser ? 'Add User' : `${user.firstName} ${user.lastName}`}
        subHeading={newUser ? `Employee ID: ${user.userId}` : ''}
      />
      { !newUser ? (
        <section className="wrapper">
          <div className="wrapper__content wrapper__content_grid">
            <div className={styles.search}>
              <UserSearchBar handleSubmit={(userId:string) => getUser({
                adminDispatch,
                appDispatch,
                userId,
              })}
              />
              <Alert 
                active={!isEmptyObject(user) && user.startDate}
                label="User Already Exists"
                type="error"
              />
            </div>
          </div>
        </section>
      ) : (
        <section>
          <User newUser />
        </section>
      )}
    </>
  );
}

export default AddUser;